module.exports = __webpack_public_path__ + "img/1887.4643d962.gif";